// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5360":"css/admin-app.6664","9221":"css/app.6664"}[chunkId] + ".css";
};